// Mock data for the website
export const recipes = [
  {
    id: 1,
    title: "Vegetarian Lasagna",
    description: "A hearty lasagna layered with ricotta, spinach, zucchini, and marinara sauce.",
    image: "/images/410.png",
    category: "vegetarian",
    prepTime: 30,
    cookTime: 45,
    servings: 6,
    difficulty: "Medium",
    ingredients: [
      "9 lasagna noodles",
      "2 cups ricotta cheese",
      "1 zucchini, sliced",
      "2 cups fresh spinach",
      "2 cups marinara sauce",
      "1 cup shredded mozzarella",
      "1/2 cup grated parmesan",
      "1 egg",
      "Salt, pepper, Italian herbs"
    ],
    instructions: [
      "Preheat oven to 375°F (190°C).",
      "Boil lasagna noodles until al dente.",
      "Mix ricotta, spinach, egg, salt, pepper, and herbs.",
      "Layer noodles, ricotta mix, zucchini, marinara, and mozzarella in baking dish.",
      "Repeat layers, top with parmesan, and bake for 40–45 minutes."
    ],
    featured: true,
    popular: true
  },
  {
    id: 2,
    title: "Chickpea and Spinach Curry",
    description: "A quick and flavorful vegetarian curry with chickpeas and spinach.",
    image: "/images/411.png",
    category: "vegetarian",
    prepTime: 10,
    cookTime: 20,
    servings: 4,
    difficulty: "Easy",
    ingredients: [
      "1 tbsp olive oil",
      "1 onion, chopped",
      "2 garlic cloves, minced",
      "1 can chickpeas",
      "3 cups spinach",
      "1 can diced tomatoes",
      "1 tsp curry powder",
      "1/2 tsp cumin",
      "Salt and pepper"
    ],
    instructions: [
      "Heat oil and sauté onions and garlic.",
      "Add spices and stir for 30 seconds.",
      "Add tomatoes and chickpeas, simmer 10 mins.",
      "Stir in spinach, cook until wilted.",
      "Serve with rice or naan."
    ],
    featured: true,
    popular: true
  },
  {
    id: 3,
    title: "Stuffed Bell Peppers",
    description: "Bell peppers filled with rice, beans, corn, and cheese.",
    image: "/images/412.png",
    category: "vegetarian",
    prepTime: 20,
    cookTime: 30,
    servings: 4,
    difficulty: "Medium",
    ingredients: [
      "4 bell peppers",
      "1 cup cooked rice",
      "1/2 cup black beans",
      "1/2 cup corn",
      "1/2 cup diced tomatoes",
      "1/2 cup shredded cheese",
      "1 tsp chili powder",
      "Salt and pepper"
    ],
    instructions: [
      "Preheat oven to 375°F (190°C).",
      "Mix rice, beans, corn, tomatoes, and cheese.",
      "Stuff peppers with mixture.",
      "Place in dish, top with cheese.",
      "Bake for 25–30 minutes."
    ],
    featured: true,
    popular: false
  },
  {
    id: 4,
    title: "Mushroom Stroganoff",
    description: "Creamy mushroom stroganoff over egg noodles.",
    image: "/images/413.png",
    category: "vegetarian",
    prepTime: 15,
    cookTime: 20,
    servings: 3,
    difficulty: "Easy",
    ingredients: [
      "2 tbsp butter",
      "1 onion, diced",
      "3 cups mushrooms",
      "2 cloves garlic",
      "1/2 cup vegetable broth",
      "1/2 cup sour cream",
      "1 tsp paprika",
      "Salt and pepper"
    ],
    instructions: [
      "Sauté onion and mushrooms in butter.",
      "Add garlic, paprika, and cook briefly.",
      "Add broth, simmer 5 mins.",
      "Stir in sour cream, season to taste.",
      "Serve over pasta or noodles."
    ],
    featured: true,
    popular: true
  },
  {
    id: 5,
    title: "Zucchini Noodles with Pesto",
    description: "Light zucchini noodles tossed in fresh basil pesto.",
    image: "/images/414.png",
    category: "vegetarian",
    prepTime: 15,
    cookTime: 5,
    servings: 2,
    difficulty: "Easy",
    ingredients: [
      "2 zucchinis, spiralized",
      "1/3 cup basil pesto",
      "1 tbsp olive oil",
      "1 clove garlic",
      "Cherry tomatoes",
      "Parmesan cheese"
    ],
    instructions: [
      "Sauté garlic in olive oil.",
      "Add zucchini noodles, cook briefly.",
      "Remove from heat and toss with pesto.",
      "Top with tomatoes and parmesan."
    ],
    featured: false,
    popular: false
  },
  {
    id: 6,
    title: "Caprese Stuffed Avocados",
    description: "Avocados filled with tomatoes, mozzarella, and basil.",
    image: "/images/415.png",
    category: "vegetarian",
    prepTime: 10,
    cookTime: 0,
    servings: 2,
    difficulty: "Easy",
    ingredients: [
      "2 ripe avocados",
      "1/2 cup cherry tomatoes",
      "1/2 cup mozzarella balls",
      "Fresh basil",
      "Balsamic glaze",
      "Salt and pepper"
    ],
    instructions: [
      "Cut avocados and remove pit.",
      "Mix tomatoes, mozzarella, basil, salt, and pepper.",
      "Stuff avocado halves with mixture.",
      "Drizzle with balsamic glaze."
    ],
    featured: true,
    popular: true
  }  
];